import React, { useState } from "react"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { useFormContext } from "../../../context/form/FormContext"
import {
  CONFIRM,
  FORGOT_PASSWORD_FORM,
  LOGIN_FORM,
  REGISTER_FORM,
  RESET_PASSWORD_FORM,
} from "../../../context/form/formTypes"
import Register from "./Register"
import Login from "./Login"
import ForgottenPassword from "./ForgottenPassword"
import ResetPassword from "./ResetPassword"
import DoublePopup from "./DoublePopup"
import Confirm from "./Confirm"
import { isBrowser } from "../../../services/browser"


const AccountPopup = ({ isOpen, handlePopup, t, resetPasswordToken }) => {
  const { content, setContent } = useFormContext()
  const [email, setEmail]  = useState(null)
  const [ fullName, setFullName ] = useState(null)
  const [updatedPassword, setUpdatedPassword] = useState(() => {
    if (isBrowser()) {
      if(window.location.search && window.location.search.includes("reset-password-token")){
        return true;
      }
    }
    return false
  });

  const renderContent = () => {
    if (content === LOGIN_FORM) {
      return (
        <DoublePopup
          isOpen={isOpen}
          handlePopup={handlePopup}
          linkTitle={t("account.register_title")}
          linkButton={t("account.register_submit")}
          linkAction={switchToRegister}
          hideSecond={updatedPassword}
        >
          <Login setContent={setContent} />
        </DoublePopup>
      )
    }
    if (content === REGISTER_FORM) {
      return (
        <DoublePopup
          isOpen={isOpen}
          handlePopup={handlePopup}
          linkTitle={t("account.register_link_title")}
          linkButton={t("account.login_link")}
          linkAction={switchToLogin}
        >
          <Register setContent={setContent} setEmail={setEmail} setFullName={setFullName}/>
        </DoublePopup>
      )
    }
    if (content === FORGOT_PASSWORD_FORM) {
      return (
        <DoublePopup
          isOpen={isOpen}
          handlePopup={handlePopup}
          linkTitle={t("account.register_title")}
          linkButton={t("account.register_submit")}
          linkAction={switchToRegister}
        >
         <ForgottenPassword setContent={setContent}/>
        </DoublePopup>
      )
    }
    if (content === RESET_PASSWORD_FORM) {
      return (
        <DoublePopup
          isOpen={isOpen}
          handlePopup={handlePopup}
          linkTitle={t("account.register_title")}
          linkButton={t("account.register_submit")}
          linkAction={switchToRegister}
        >
         <ResetPassword
            resetPasswordToken={resetPasswordToken}
            setContent={setContent}
          />
        </DoublePopup>
      )
    }
    if (content === CONFIRM ) {
      return (
        <DoublePopup
          isOpen={isOpen}
          handlePopup={handlePopup}
          hideSecond
        >
         <Confirm
            setContent={setContent}
            email={email}
            fullName={fullName}
          />
        </DoublePopup>
      )
    }
  }

  const switchToRegister = () => {
    setContent(REGISTER_FORM)
  }

  const switchToLogin = () => {
    setContent(LOGIN_FORM)
  }

  return <>{renderContent()}</>
}

export default withTranslation()(AccountPopup)
